var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, IconButton, InputLabel, MenuItem, Select, TextField, useMediaQuery, useTheme } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { RoleCategories } from '../../../../application/common/constants/role-categories';
import { useGetAllCompaniesQuery } from '../../../../application/features/companies/company-api';
import { useCreateRoleMutation } from '../../../../application/features/roles/role-api';
import { useAppSelector } from '../../../../application/store/useStore';
import useTranslate from '../../../../localization/helpers';
import RightArrow from '../../../icons/components/right-arrow';
import { X } from 'react-feather';
var CreateRole = function (_a) {
    var open = _a.open, onClose = _a.onClose;
    var theme = useTheme();
    var navigate = useNavigate();
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var currentCompany = useAppSelector(function (state) { return state.common; }).currentCompany;
    var _b = useTranslate(), translate = _b.translate, tWithField = _b.tWithField, tWithFunction = _b.tWithFunction;
    var isXs = useMediaQuery(theme.breakpoints.only('xs'));
    var _c = __read(useState(false), 2), managePermissions = _c[0], setManagePermissions = _c[1];
    var _d = __read(useCreateRoleMutation(), 2), triggerCreateRole = _d[0], _e = _d[1], isLoading = _e.isLoading, isSuccess = _e.isSuccess, createdRole = _e.data;
    var _f = useGetAllCompaniesQuery({
        filterByCompany: true
    }), _g = _f.data, companies = _g === void 0 ? [] : _g, isCompaniesLoading = _f.isLoading, isCompaniesFetching = _f.isFetching;
    var _h = useForm({
        defaultValues: {
            name: '',
            category: '',
            companies: []
        }
    }), control = _h.control, handleSubmit = _h.handleSubmit, reset = _h.reset, errors = _h.formState.errors;
    useEffect(function () {
        if (isSuccess && createdRole) {
            enqueueSnackbar(tWithField('toolTips.createSuccess', 'common.role'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            if (managePermissions) {
                navigate("/roles-permissions/".concat(createdRole.id));
            }
            reset();
            onClose();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess, createdRole]);
    var onSubmit = function (role) {
        if ((currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) !== RoleCategories.SuperAdmin && currentCompany) {
            role.companies = [currentCompany.id];
        }
        triggerCreateRole(role);
    };
    var closeDialog = function () {
        reset();
        onClose();
    };
    return (_jsxs(Dialog, { fullWidth: true, maxWidth: 'sm', open: open, onClose: closeDialog, children: [_jsxs(DialogTitle, { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }, children: [tWithFunction('actions.addFunction', 'common.role'), _jsx(IconButton, { color: 'inherit', style: { marginLeft: 'auto' }, onClick: onClose, children: _jsx(X, { size: 20, color: theme.palette.action.active }) })] }), _jsx(DialogContent, { children: _jsxs("form", { noValidate: true, children: [_jsx(Controller, { name: 'name', control: control, rules: {
                                required: {
                                    value: true,
                                    message: tWithField('validations.fieldIsRequired', 'common.name')
                                },
                                maxLength: {
                                    value: 256,
                                    message: translate('validations.maximumCharactersAllowed', { count: 256 })
                                },
                                pattern: {
                                    value: /^[A-Za-z\s]+$/,
                                    message: translate('validations.charactersAllowed')
                                }
                            }, render: function (_a) {
                                var _b;
                                var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                return (_jsxs(FormControl, { variant: 'outlined', fullWidth: true, size: 'small', children: [_jsx(TextField, { autoFocus: true, margin: 'dense', label: translate('common.role'), type: 'text', disabled: isLoading, fullWidth: true, value: value, onChange: onChange, error: !!errors.name, slotProps: { input: { sx: { borderRadius: '8px' } } } }), _jsx(FormHelperText, { error: true, children: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message })] }));
                            } }), _jsx(Controller, { name: 'category', control: control, rules: {
                                required: {
                                    value: true,
                                    message: tWithField('validations.fieldIsRequired', 'roles.category')
                                }
                            }, render: function (_a) {
                                var _b;
                                var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                return (_jsxs(FormControl, { variant: 'outlined', fullWidth: true, size: 'medium', margin: 'dense', children: [_jsx(InputLabel, { children: translate('roles.category') }), _jsxs(Select, { label: translate('roles.category'), disabled: isLoading, value: value, onChange: onChange, error: !!errors.category, slotProps: {
                                                input: { 'aria-label': 'Category' }
                                            }, children: [_jsx(MenuItem, { value: 'Others', children: translate('roles.others') }), _jsx(MenuItem, { value: 'Technician', children: translate('common.technician') })] }), _jsx(FormHelperText, { error: true, children: (_b = errors.category) === null || _b === void 0 ? void 0 : _b.message })] }));
                            } }), (currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin && (_jsx(Grid, { size: { xs: 12 }, children: _jsx(Controller, { name: 'companies', control: control, rules: {
                                    required: {
                                        value: true,
                                        message: tWithField('validations.fieldIsRequired', 'common.company')
                                    }
                                }, render: function (_a) {
                                    var _b;
                                    var _c = _a.field, onChange = _c.onChange, value = _c.value;
                                    return (_jsxs(FormControl, { fullWidth: true, children: [_jsx(Autocomplete, { noOptionsText: translate('common.noOptions'), multiple: true, disabled: isLoading || isCompaniesLoading, loading: isCompaniesFetching, options: companies.filter(function (company) { return company.isActive === true; }), value: companies.filter(function (company) { return value.includes(company.id); }), isOptionEqualToValue: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { return option.name; }, disableCloseOnSelect: true, slotProps: { chip: { size: 'small', variant: 'soft' } }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { variant: 'outlined', fullWidth: true, label: translate('common.companies'), error: !!errors.companies }))); }, onChange: function (_, value) {
                                                    onChange(value.map(function (val) { return val.id; }));
                                                }, renderOption: function (props, option, _a) {
                                                    var selected = _a.selected;
                                                    return (_createElement("li", __assign({}, props, { key: option.id }),
                                                        _jsx(Checkbox, { style: { marginRight: 8 }, checked: selected }),
                                                        option.name));
                                                }, sx: {
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: '8px',
                                                        '&.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
                                                            padding: '3.5px 4px 3.5px 8px'
                                                        }
                                                    }
                                                } }), _jsx(FormHelperText, { error: true, children: (_b = errors.companies) === null || _b === void 0 ? void 0 : _b.message })] }));
                                } }) }))] }) }), _jsxs(DialogActions, { children: [_jsx(Button, { sx: {
                            '& .MuiButton-endIcon': {
                                mb: '1px'
                            }
                        }, disabled: isLoading, onClick: function () {
                            setManagePermissions(true);
                            handleSubmit(onSubmit)();
                        }, size: 'medium', variant: 'outlined', color: 'inherit', endIcon: _jsx(RightArrow, {}), children: isXs ? translate('roles.permissions') : translate('roles.addManagePermissions') }), _jsx(Button, { disabled: isLoading, size: 'medium', variant: 'contained', color: 'inherit', onClick: function () {
                            setManagePermissions(false);
                            handleSubmit(onSubmit)();
                        }, children: translate('actions.addNow') })] })] }));
};
export default CreateRole;
